import type { AxiosRequestConfig } from 'axios';
import z from 'zod';

import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const SyncAlertConfigDtoSchema = z.object({
  id: z.number(),
  enabled: z.boolean(),
  alertEmails: z.array(z.string()),
  slackWebhookUrl: z.string().nullable(),
  updatedAt: z.string(),
});

export type SyncAlertConfigDto = z.infer<typeof SyncAlertConfigDtoSchema>;

export const getSyncAlertConfig = (config?: AxiosRequestConfig) => {
  return api
    .get('/sync-alert-config', config)
    .then(responseContract(SyncAlertConfigDtoSchema));
};
